import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';

import { company } from '~/company/Company';
import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { useProductCardV3 } from '~/components/ProductCardV3/hooks/useProductCardV3';
import type { ProductCardVariantProps } from '~/components/ProductCardV3/types';
import { formatPriceWithCurrency } from '~/utils/formaters';

import styles from './ProductCardHorizontal.module.scss';

const ProductCardHorizontal = observer(
  ({
    product,
    className,
    productState,
    disabled = false,
  }: ProductCardVariantProps) => {
    const { currentItem, image, currentPrice } = useProductCardV3(
      product,
      productState?.selectedOffer,
    );

    const imageUrl = currentItem.images?.[0] || image || '';
    const productName = currentItem.name || '';

    return (
      <div
        className={classes([
          styles.card,
          disabled && styles.disabled,
          className,
        ])}
        data-company={company.name}
      >
        <div className={styles.imageWrapper}>
          <CloudflareResponseImage
            src={imageUrl}
            srcParams={{ width: 144, height: 144, fit: 'contain' }}
            alt={productName}
            loading="lazy"
            className={styles.image}
          />
        </div>
        <div className={styles.details}>
          <span className={styles.name}>{productName}</span>
          {currentPrice && (
            <p className={styles.price}>
              {typeof currentPrice === 'number'
                ? formatPriceWithCurrency(currentPrice)
                : currentPrice}
            </p>
          )}
        </div>

        {disabled && <div className={styles.disabledOverlay} />}
      </div>
    );
  },
);

export default ProductCardHorizontal;
